import useMainMenu from "@/hooks/useMainMenu";
import cn from "classnames";
import { Dropdown, Nav } from "react-bootstrap";

import classes from "./styles.module.scss";

export const MainMenu = ({ className }) => {
  const menu = useMainMenu();

  return (
    <Nav className={cn(className, classes.MainMenu)}>
      {menu.map(({ title, href, children }, index) => {
        if (children.length === 0) {
          return (
            <Nav.Item key={index}>
              <Nav.Link href={href} target={href.startsWith("http") ? "_blank" : "_self"}>
                <span>{title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        }

        return (
          <Dropdown key={index}>
            <Nav.Item>
              <Nav.Link href={href} className="text-l">
                <span>{title}</span>
              </Nav.Link>
              <Dropdown.Toggle />
            </Nav.Item>

            <Dropdown.Menu data-bs-theme="dark" className="shadow-sm">
              {children.map((child, idx) => (
                <Dropdown.Item as={Nav.Item} key={idx}>
                  <Nav.Link
                    href={child.href}
                    target={child.href.startsWith("http") ? "_blank" : "_self"}
                  >
                    <span>{child.title}</span>
                  </Nav.Link>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        );
      })}
    </Nav>
  );
};
